import { render, staticRenderFns } from "./PremiumType.vue?vue&type=template&id=063650ee"
import script from "./PremiumType.vue?vue&type=script&lang=js"
export * from "./PremiumType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports